import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stunning%20artistic%20manga%20illustration%20with%20dynamic%20action%20scene%20featuring%20multiple%20anime%20style%20characters%20in%20vibrant%20poses%20against%20a%20warm%20sunset%20gradient%20sky%20with%20floating%20cherry%20blossom%20petals%20and%20energy%20effects%2C%20Japanese%20manga%20aesthetic%2C%20rich%20warm%20colors%2C%20cinematic%20composition%2C%20epic%20scale&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
        alt="爱漫画 - 免费漫画在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-screen-2xl mx-auto px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-fire-line text-sm text-accent-400"></i>
            </div>
            <span className="text-sm text-white/90">每日更新 100+ 热门漫画</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
            免费漫画<span className="text-primary-400">在线阅读</span>平台
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            海量国漫、日漫、韩漫资源，支持下拉式畅快阅读体验。随时随地，想追就追！
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/rexue"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-line"></i>
                </div>
                立即开始阅读
              </span>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-medium rounded-lg border border-white/20 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="grid grid-cols-3 gap-6 mt-12 max-w-lg mx-auto">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">10万+</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">漫画资源</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">每日更新</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">持续追更</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">全免费</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">无广告打扰</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/50 text-xl"></i>
        </div>
      </div>
    </section>
  );
}